<div class="flex items-center w-full px-5 gap-3 h-[60px] overflow-hidden">
    <!-- Logo -->
    <div class="flex items-center justify-center flex-shrink-0 w-8 h-8">
        <img
            class="w-8 h-8 object-contain"
            src="assets/images/logo/logo.png"
            alt="Logo image">
    </div>

    <!-- Brand — fades out smoothly when switching to thin mode -->
    <div class="flex flex-col justify-center min-w-0 transition-all duration-300 ease-out"
         [ngClass]="isClassyLayout ? 'opacity-100 max-w-[160px]' : 'opacity-0 max-w-0 overflow-hidden'">
        <span class="text-[15px] font-semibold text-white tracking-[0.02em] leading-tight whitespace-nowrap">Zeitune</span>
        <span class="text-[9px] font-semibold uppercase tracking-[0.16em] leading-tight mt-0.5 whitespace-nowrap"
              style="color: rgba(155, 213, 100, 0.55);">Insurance</span>
    </div>
</div>
<div class="mx-5 h-px transition-opacity duration-300"
     [ngClass]="isClassyLayout ? 'opacity-100' : 'opacity-0'"
     style="background: rgba(255,255,255,0.06);"></div>
